import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class FluxoService extends CRUDService{
    constructor() {
        super("fluxo");
    }

    listSolicitacoesEmAndamento() {
        return http.get(this.serviceName + "/tarefas/andamento")
    }

    listarTarefasSolicitacaoPorUsuario() {
        return http.get(this.serviceName + "/solicitacao/tarefas/usuario")
    }
    carregarSolicitacao(idSolicitacao) {
        return http.get("/"+this.serviceName+"/detalhes/"+idSolicitacao);
    }

    carregarDetalhesSolicitacaoByEttId(idSolicitacaoEtt) {
        return http.get("/"+this.serviceName+"/detalhesContratacao/"+idSolicitacaoEtt);
    }

    get(taskIdBpm) {
        return http.get("/"+this.serviceName + "/solicitacao/tarefa/"+taskIdBpm)
    }

    getSolicitacaoContratacao(taskIdBpm) {
        return http.get("/"+this.serviceName + "/solicitacao-contrato/tarefa/"+taskIdBpm)
    }
    getDetalheSolicitacaoContratacao(solicitacaoId) {
        return http.get("/"+this.serviceName + "/solicitacao-contrato/detalhe/"+solicitacaoId)
    }

    getProrrogacaoContrato(taskIdBpm) {
        return http.get("/"+this.serviceName + "/prorrogar-contrato/tarefa/"+taskIdBpm)
    }

    // rota para a solicitação de contratação
    solicitarContratacao(tramiteSolicitacao) {
        return http.post("/"+this.serviceName+"/solicitacao-contratacao/iniciar", tramiteSolicitacao);
    }

    // rota para a solicitação de término antecipado
    anteciparTermino(solicitacaoEttId, dataFinalAntecipada, razao) {
        return http.post("/"+this.serviceName+"/termino-antecipado/iniciar", {solicitacaoEttId: solicitacaoEttId, dataFinalAntecipada: dataFinalAntecipada, razao: razao} );
    }
    // rota para a solicitação de prorrogação
    prorrogar(tramiteProrrogacao) {
        return http.post("/"+this.serviceName+"/prorrogar-contrato/iniciar", tramiteProrrogacao);
    }

    carregarDetalhesSolicitacaoByProrrogacaoId(solicitacaoEttId, prorrogacaoId) {
        return http.get("/"+this.serviceName+"/prorrogar-contrato/detalhe/"+solicitacaoEttId+"/"+prorrogacaoId);
    }

    carregarDetalhesSolicitacaoByTerminoAntecipadoId(solicitacaoEttId, terminoAntecipadoId) {
        return http.get("/"+this.serviceName+"/termino-antecipado/detalhe/"+solicitacaoEttId+"/"+terminoAntecipadoId);
    }

    obterUrlSolicitacaoRetroativa(solicitacaoEttId, tipo) {
        return http.get("/solicitacao/url-retroativa/"+solicitacaoEttId+"/"+tipo);
    }

    verificaSeExisteCargoNoPcp(cargoId) {
        return http.get("/"+this.serviceName+"/verificaSeExisteCargoNoPcp?cargoId="+cargoId);
    }

    tramitar(id, tipoFluxo, idSolicitacao, outcome, razao, comentario, detalhesTarefa, listaAprovadores = []) {
        return http.post("/"+this.serviceName+"/tarefa/"+id+"/tramitar", {idTarefaBpm: id, tipoFluxo: tipoFluxo, idSolicitacao: idSolicitacao, outcome: outcome, razao: razao, comentario: comentario, detalhesTarefa: detalhesTarefa, listaAprovadores: listaAprovadores});
    }
    tramitarFluxo(tramiteFluxo) {
        return http.post("/"+this.serviceName+"/tramitar", tramiteFluxo);
    }
    
    getEvolucaoFluxo(idFluxo){
        const taskIdBpm = window.location.href.includes("?id=") ? window.location.href.split("?id=")[1] : window.location.href.split("/").slice(-1)[0];
        if(idFluxo && taskIdBpm && taskIdBpm !== "")
            return http.get("/"+this.serviceName + "/evolucao/"+ idFluxo);
        else
            //tratamento para não quebrar o detalhamento da prorrogação e término antecipado
            return Promise.resolve(null); 
    }

    getHistoricoFLuxo(tipoFluxo, idSolicitacao){
        return http.get("/"+this.serviceName+"/historico/"+ tipoFluxo + "/"+idSolicitacao);
    }

    migrarFluxo(listaParaMigrar) {
        return http.post("/" + this.serviceName + "/migrar-bpm", listaParaMigrar);
    }

    cancelarFluxo(lista, observacao){
        return http.post("/" + this.serviceName + "/cancelar", { listCancelamento: lista, observacao: observacao});
    }

    delegar(listaTarefas, matriculaDelegado) {
        return http.post("/" + this.serviceName + "/delegar", { listIdsTarefas: listaTarefas, matriculaDelegado: matriculaDelegado});
    }

    transferir(listaTarefas, loginUsuario) {
        return http.post("/" + this.serviceName + "/transferir", { idTasks: listaTarefas, loginUsuario: loginUsuario});
    }
}